export const STORES = {
  APPLE: 'Apple',
  ANDROID: 'Android',
}
